const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_expo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.979,20.059,11.252,6.2l7.155-3.835,2.127,1.074L13.422,7.457l7.349,22.088L18.407,28.17l-5.5-12.677-7.22,5.479Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.24,
    cy: 13.967,
    rx: 2.686,
    ry: 2.503,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2,12.85a2.433,2.433,0,0,0-4.158.3,2.19,2.19,0,0,0,.419,2.449A3.546,3.546,0,0,0,27.2,12.85ZM19.976,3.4l-1.547-.849L11.693,6.3l.537.29,1.02.537L15.1,6.1l4.878-2.718Zm.623-.258a.24.24,0,0,1,.172.161L23.027,9.96a.223.223,0,0,1-.108.29,4.361,4.361,0,0,0-2.105,4.985,4.607,4.607,0,0,0,4.92,3.244.284.284,0,0,1,.279.172l2.331,6.833a.275.275,0,0,1-.107.3l-7.166,4.189a.263.263,0,0,1-.107.022.285.285,0,0,1-.193-.032l-2.514-1.58a.253.253,0,0,1-.108-.107L13.24,16.986,5.762,21.24a.27.27,0,0,1-.053.022.258.258,0,0,1-.237-.011l-1.7-.967a.247.247,0,0,1-.108-.322L10.93,6.178a.255.255,0,0,1,.118-.107l7.241-4.039a.274.274,0,0,1,.258,0ZM11.617,6.844l-.354-.182-7,13.332,1.279.72,6.037-7.9a.3.3,0,0,1,.248-.108.3.3,0,0,1,.214.161l6.575,15.148L20.373,29.1,13.315,8.467l-.3-.86-1.407-.773Zm10.829,7.95a2.73,2.73,0,0,1,1.343-3.115,2.965,2.965,0,0,1,3.481.43,2.717,2.717,0,0,1,.078,3.843q-.037.039-.078.078a2.932,2.932,0,0,1-4.824-1.236Z",
    style: {
      fill: "#4630eb"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpo);
export default __webpack_public_path__ + "static/media/expo.0537295a1390ab280abc6b075d30a5ce.svg";
export { ForwardRef as ReactComponent };